import React from 'react'
import { string, shape } from 'prop-types'

export default function DynamicTextBlock({ field }) {
  const id = `dynamic-text-block-${field.id}`
  return (
    <section
      id={id}
      className="dynamic-text-block-wrapper"
      data-testid="dynamic-form-text-block"
      style={{
        visibility: field.visibility === 'hidden' ? 'hidden' : 'visible',
      }}
    >
      {' '}
      <p>{field.label}</p>
    </section>
  )
}

DynamicTextBlock.propTypes = {
  field: shape({
    label: string,
  }).isRequired,
}
